import React from 'react';
import { ProgressBar, StackLayout } from '@leagueplatform/genesis-core';
import { ProgramDetailCard } from '@leagueplatform/health-journey-common';
import { useIntl } from '@leagueplatform/locales';
import { YourRanking } from '#pages/challenge-landing-page/components/sidebar/components/your-ranking/your-ranking.component.tsx';
import { useGetChallengeByIdData } from '#pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts';

export const ProgressTracker = () => {
  const { formatMessage } = useIntl();
  const { data: challengeData } = useGetChallengeByIdData();
  // Trust that challenge data exists as parent components would not render without it
  const { challengeType, totalActivities, userChallenge } = challengeData!.data;
  const progress = userChallenge?.data.progress;
  // if completed activities aren't included, default to 0
  const completedActivities = progress?.completedActivities || 0;

  // if for some reason we don't have the total number of activities, don't show progress
  if (!totalActivities) {
    return null;
  }
  const isGroupChallenge = challengeType === 'group';

  const completionPercentage = Math.round(
    (completedActivities / totalActivities) * 100,
  );

  return (
    <ProgramDetailCard>
      <StackLayout
        horizontalAlignment="stretch"
        spacing="$oneAndHalf"
        orientation={{
          '@mobileLandscape': 'horizontal',
          '@tablet': 'horizontal',
          '@initial': 'vertical',
        }}
      >
        <StackLayout spacing="$half" horizontalAlignment="stretch">
          <ProgressBar
            label={formatMessage({ id: 'CHALLENGE_PROGRESS' })}
            leadingValue={formatMessage(
              { id: 'X_PERCENT_COMPLETE' },
              { number: completionPercentage },
            )}
            trailingValue={formatMessage(
              { id: 'X_OF_Y_ACTIVITIES' },
              { completed: completedActivities, total: totalActivities },
            )}
            fillProgressValue={completedActivities}
            maxProgressValue={totalActivities}
            labelPosition="topLeading"
            accessibilityLabel={formatMessage(
              { id: 'X_OF_Y_ACTIVITIES_COMPLETED' },
              { completed: completedActivities, total: totalActivities },
            )}
          />
        </StackLayout>
        {isGroupChallenge && <YourRanking />}
      </StackLayout>
    </ProgramDetailCard>
  );
};
